import React, { useEffect, useState, useMemo } from 'react'
import { Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import { NUMERO_DECIMALE, NUMERO_INTERO, NUMERO_INTERO_NEGATIVO, NUMERO_DECIMALE_NEGATIVO } from '../../libQuestionario/constants';
import { Formatter } from 'gf-ui';

const InputNumber = ({kid, type=NUMERO_INTERO, item, domande, risposte_all, value, onChange}) => {    

  const [visibile, mostra] = useState(false)  
  const domanda = item.DESCRIZIONE;    
  const mostraSe = item.ARR_RIFERIMENTI;   
  const placeholder = item.ARR_RISPOSTE[0].DESCRIZIONE;

  const allowNegativeValue = useMemo(()=>{
    switch(type){
      case NUMERO_INTERO:
      case NUMERO_DECIMALE:            
        return false;
      case NUMERO_INTERO_NEGATIVO:
      case NUMERO_DECIMALE_NEGATIVO:      
        return true;
      default:
        return false;
    }
  }, [type])

  const allowDecimals = useMemo(()=>{
    switch(type){
      case NUMERO_INTERO:      
      case NUMERO_INTERO_NEGATIVO:
        return false;      
      case NUMERO_DECIMALE:            
      case NUMERO_DECIMALE_NEGATIVO:      
        return true;
      default:
        return false;
    }
  }, [type])

  const selVal = (val) => {                        
    onChange(kid, val, type)            
  }
  
  useEffect(()=>{             
    if( mostraSe.length === 0 ){
      mostra(true);
    }else{        
      let mostraDomanda = false;      
      Object.keys(mostraSe).forEach( idx => {
        const domanda_rif = mostraSe[idx];                        
        if( risposte_all.indexOf(domanda_rif.ID_MA_CSS_D_R) >= 0 ){
          mostraDomanda = true;
        }               
      })
      mostra(mostraDomanda)
    }    
  }, [domande, mostraSe, risposte_all])

  useEffect(()=>{
    if(!visibile && !Formatter.isStringaVuota(value)){      
      onChange(kid, null)
    }
  }, [kid, onChange, value, visibile])

  return (
    <>      
      { visibile && (
      <Form.Group className="mb-3 form-group">
        <div className={`form-control p-0 bg-white`} style={{border: `1px solid ${value?'green':'lightgrey'}`, borderRadius: '10px'}}>
          <div className={`form-control ${(value !== undefined && value !== "") ? "is-valid" : ""}`} style={{border: 'none', borderRadius: '10px'}}>
            <div className='form-label fw-bold' dangerouslySetInnerHTML={{__html: domanda}} />
          </div>
          <div className='px-4 pb-4'>
            <CurrencyInput                                         
              allowDecimals={allowDecimals ? true : false} 
              decimalsLimit={allowDecimals ? 2 : 0}
              allowNegativeValue={allowNegativeValue}
              prefix={""}
              maxLength={10}
              disableGroupSeparators={true}              
              intlConfig={{ locale: 'it-IT'}}       
              className={"form-control"}
              onValueChange={(value, name) => selVal(value)}
              value={Formatter.isStringaVuota(value) ? "" : value}
              style={{width: '200px'}}                                                                        
              placeholder={placeholder}
            />
            {/* <Form.Control as="input" 
                          type="text" 
                          pattern="\d*"
                          aria-label={domanda}                     
                          onChange={(e) => selVal(e.target.value)}
                          value={value} 
                          placeholder={placeholder}
                          required={item.FLG_OBBLIGATORIA==="-1"} 
                          style={{width: '200px'}}                                                                        
                          />                               */}
          </div>
        </div>
      </Form.Group>
      )}
    </>
  )
}

export default InputNumber;